export default "__VITE_ASSET__CchaW5oK__"